var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('MyHeaderVue1'),_c('MyHeaderVue'),_c('router-view'),_c('MyFooterVue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }